<template>
  <div>
    <el-form ref="form" :model="curInput.input" :rules="rules" label-width="100px">
      <el-form-item label="可选控件类型" prop="allow_type">
        <el-checkbox-group v-model="curInput.control.allow_type">
          <el-checkbox v-for="(item, index) in inputTypes" :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import modelConfig from '../../../config/modelConfig'
  export default {
    props: ['curInput'],
    data() {
      return {
        inputTypes: [  // 可选控件类型
          { id: 10, name: '单行文本' }
          // { id: 20, name: '密码' },
          // { id: 30, name: '多行文本' },
          // { id: 40, name: '单选框' },
          // { id: 50, name: '复选框' },
          // { id: 60, name: '下拉框' },
          // { id: 70, name: '日期' },
          // { id: 80, name: '日期时间' },
          // { id: 90, name: '时间' },
          // { id: 100, name: '富文本' },
          // { id: 110, name: '级联选择' },
          // { id: 120, name: '外键选择' },
          // { id: 130, name: '子表单' },
          // { id: 140, name: '文件上传' },
          // { id: 150, name: '人员选择' },
          // { id: 160, name: '部门选择' },
          // { id: 170, name: '用户信息' },
          // { id: 180, name: '获取系统时间' },
          // { id: 190, name: '参数管理' }
        ]
      }
    },
    mixins: [modelConfig]
  }
</script>


// WEBPACK FOOTER //
// paramsConfig.vue?1f67bb64